import axios from "axios";
import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectCardCoupon(data) {
  return request({
    // headers: {
    //   "Content-Type": "application/x-www-form-urlencoded",
    // },
    url: `/admin/mall/cardCoupon/selectCardCoupon`,
    method: "POST",
    data,
  });
}

/**
 * 新增
 * @param {*} data
 * @returns
 */
export function addVipcardRecoder(data) {
  return request({
    url: `/admin/mall/cardCoupon/add`,
    method: "POST",
    data,
  });
}

/*删除 */
export function deleteCardCoupon(data) {
  return request({
    url: `/admin/mall/cardCoupon/delete`,
    method: "POST",
    data,
  });
}
